export const keepUnusedDataFor = 60 * 5;
export const apiUri = process.env.NODE_ENV === 'development'
	? `${window.location.protocol}//${window.location.hostname}:3001`
	: "https://api.drapes.app";
